import React, { useCallback, useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route ,Navigate} from "react-router-dom";
import Home from "./pages/Home/Home";
import Sidebar from "./components/Sidebar/Sidebar";
import { RenderProvider } from "./context/renderContext";
import TopBar from "./components/TopBar";
import LoginPopup from "./components/loginPopup";
import Feedback from "./pages/Feedback/Feedback";
import { AuthProvider } from "./context/authContext";
import Analytics from "./pages/Test/Analytics";
import { ThemeProvider } from "./context/themeContext";
import Mood from "./pages/MoodInsights/Mood";
import GrievancesDashboard from "./pages/Grivance/main"
import GrievanceCaseDetail from "./pages/Grivance/Grievancecasedetail"

function App() {
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
    } else {
      setIsLoginOpen(true);
    }
  }, []);

  const handleLoginSuccess = useCallback(() => {
    setIsLoggedIn(true);
    setIsLoginOpen(false);
  }, []);

  return (
    <Router>
      <ThemeProvider>
        <AuthProvider>
          <RenderProvider>
            <div className="flex h-screen overflow-hidden bg-[#f1f2fa] dark:bg-[#10151F] transition-colors duration-300">
              {/* Sidebar (desktop only) */}
              <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />

              {/* Right Side */}
              <div className="flex flex-1 flex-col overflow-hidden">
                <TopBar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />

                <main className="flex-1 mt-[60px] lg:mt-0 overflow-y-auto bg-[#f1f2fa] dark:bg-[#10151F] transition-colors duration-300">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/analytics" element={<Analytics />} />
                    <Route path="/mood" element={<Mood />} />
                    <Route path="/grievances" element={<GrievancesDashboard/>} />
                    <Route path="/grievances/:caseId" element={<GrievanceCaseDetail />} />
                   <Route path="*" element={<Navigate to="/" replace />} />
                 
                  </Routes>
                </main>
              </div>

              <LoginPopup
                open={isLoginOpen}
                onClose={() => {
                  if (isLoggedIn) setIsLoginOpen(false);
                }}
                onLoginSuccess={handleLoginSuccess}
              />
            </div>
          </RenderProvider>
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
